import React from 'react';
import BaseActionForm from '../BaseActionForm';
import { Button } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import './styles.scss';
import { useNavigate } from 'react-router-dom'

export default function ImportDataset(props) {
    const navigation = useNavigate() // extract navigation prop here 
    return <ImportDatasetClass {...props} navigation={navigation} exitCross={props.exitCross}/> //pass to your component.
}
class ImportDatasetClass extends BaseActionForm {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            selectedFile: null,
            importResult: null,
            labelsInFirstRow: true,
            disableButton: false
        }
    }

    async componentDidMount() {
        super.componentDidMount();

    }

    onFileChange = (event) => {
        let files = event.target.files;
        if (files && files[0]) {
            this.setState({ selectedFile: files[0], importResult: null });
        }
        else this.setState({ importResult: null })
    };

    onFileUpload = () => {
        if (this.state.selectedFile) {
            ApiService.uploadDataset(this.state.selectedFile, this.state.labelsInFirstRow, (this.props.choosenDataset ? this.props.choosenDataset.dataset : null)).then((response) => {
                this.setState({ disableButton: false });
                this.setState({ importResult: response });
            });
        }
    };

    renderMain = () => {
        return (
            <div id={`importDataset` + (this.props.choosenDataset ? 'TwoHalfs' : '')} className="flexColumn rightPanel">
                <div className="headerContainer">
                    <div className='titleContainer'><p className="headerMargin">{this.props.choosenDataset ? `Импорт в ${this.props.choosenDataset.name}` : 'Импорт'}</p></div>
                </div>

                <div className="postHeaderContainer textRoboto">
                    {this.renderAlerts()}

                    {(this.state.selectedFile)
                        ?
                        <div className='infoContainer'>
                            {this.state.selectedFile.name && <p className={'leftImportMargin'}>Выбран файл: {this.state.selectedFile.name}</p>}
                            {/*<p>Тип: {this.state.selectedFile.type}</p>*/}
                            {this.state.selectedFile.lastModifiedDate && this.state.selectedFile.lastModifiedDate.toDateString && <p className={'leftImportMargin'}>Последние изменения: {this.state.selectedFile.lastModifiedDate.toDateString()}</p>}

                            {(this.state.selectedFile.name.indexOf(".xls") >= 0) &&
                                // <Form.Check
                                //     inline
                                //     checked={this.state.labelsInFirstRow}
                                //     type={'checkbox'}
                                //     className={'leftImportMarginCheck'}
                                //     label={'Названия полей в первой строке'}
                                //     onChange={(event) => (this.setState({ labelsInFirstRow: !this.state.labelsInFirstRow }))} />
                                <div className='switchInput leftImportMargin' >
                                    <input type="checkbox" checked={this.state.labelsInFirstRow} id="switch" onChange={(event) => {
                                        this.setState({ labelsInFirstRow: !this.state.labelsInFirstRow });
                                    }} />
                                    <label htmlFor="switch" id='switchLabel' /><p>Названия полей в первой строке</p>
                                </div>
                            }


                            {(this.state.importResult)
                                ?
                                <div>
                                    {(this.state.importResult.status === "success")
                                        ?
                                        <div>
                                            <p className={'leftImportMargin'}>{`Файл загружен, ${this.props.choosenDataset ? "" : "создан набор данных, "} запущен импорт`}</p>
                                            {this.props.choosenDataset ? (
                                                <Button 
                                                    className={'leftImportMargin applyInstrument'} 
                                                    onClick={() => { 
                                                        const imgTag = this.props.exitCross(); 
                                                        imgTag.props.onClick();
                                                    }}>
                                                    Перейти к набору
                                                </Button>
                                            )
                                            : (
                                                <Button 
                                                    className={'leftImportMargin applyInstrument'} 
                                                    onClick={() => { 
                                                        this.goToSection(this.props.navigation, "MyDatasets"); 
                                                    }}>
                                                    Перейти к списку наборов
                                                </Button>
                                            )}
                                        </div>
                                        :
                                        <p className={'leftImportMargin'}>Произошла ошибка: {this.state.importResult.errorMessageRu}</p>
                                    }
                                </div>
                                : (
                                    <Button
                                        disabled={this.state.disableButton} 
                                        className={'leftImportMargin applyInstrument'} 
                                        onClick={() => {
                                            this.setState({ disableButton: true });
                                            this.onFileUpload();
                                        }}
                                    >
                                        Импортировать набор данных
                                    </Button>
                                )
                            }
                        </div>
                        :
                        <div className='infoContainer'>
                            <p className="textBottom">Принимаются форматы Excel, GeoJSON и Zip</p>
                        </div>
                    }
                    <input
                        id="file-upload"
                        type="file"
                        style={{ display: 'none' }}
                        onChange={this.onFileChange} />

                    <label htmlFor="file-upload" className="greenButton">
                        <p>Выбрать файл</p>
                    </label>
                </div>
                {this.state.message}
            </div >
        );
    }

    render() {

        return (
            <>
                {this.props.choosenDataset ? (
                    <div className='twoHalfs'>
                        {this.renderMain()}
                        <div className='rightHalf'></div>
                    </div>
                ) : (
                    <>
                        {this.renderMain()}
                    </>
                )}
            </>
        );
    }
}

